import { addStyles } from 'ethcss'
import { colors, grid, IStyles, item } from 'theme'
import { defaultThemeStyles } from 'blocks.app/app/app.theme.jcss'
import { mediaCSS, textSizes } from 'theme/media'

const styles: IStyles = {
    iconWrapper: {
        position: 'relative',
        padding: '24px 0 66px 0',
        backgroundColor: colors.greyLight,
    },
    noLicense: {
        position: 'absolute',
        top: 'calc(50% - 16px)',
        left: 0,
        width: '100%',
        transform: 'translateY(-50%)',
    },
    menuPanel: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: 42,
        backgroundColor: colors.grey,
    },
}

addStyles(styles)
export default styles
